// This file is automatically generated. Do not edit it directly.
import { getSupabaseConfig } from "@/config/supabase";
import { createClient, SupabaseClient } from "@supabase/supabase-js";

const { url: supabaseUrl, anonKey: supabaseAnonKey } = getSupabaseConfig();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Supabase URL und Anon Key müssen in der .env Datei definiert sein"
  );
}

// Globaler Singleton: Verhindert mehrere GoTrueClient Instanzen
declare global {
  // Verhindert Hot-Reload-Dopplungen in Vite
  // eslint-disable-next-line no-var
  var __supabase__: SupabaseClient<any> | undefined;
}

/**
 * In-Memory-Lock statt navigator.locks: Bei Resume refetchen viele Queries parallel;
 * der Default-Lock wartet 5 s und erzwingt dann „steal“ → Konsolen-Sturm + AbortErrors.
 * Serialisiert Auth-Zugriffe ohne Cross-Tab-Koordination (PWA reicht hier).
 */
function createInMemoryAuthLock(): <
  R,
>(
  _name: string,
  _acquireTimeout: number,
  fn: () => Promise<R>
) => Promise<R> {
  let chain: Promise<void> = Promise.resolve();
  return async (_name, _acquireTimeout, fn) => {
    const run = chain.then(() => fn());
    chain = run.then(
      () => undefined,
      () => undefined
    );
    return run;
  };
}

// Standard Supabase Client mit eindeutigem storageKey
export const supabase = (() => {
  if (globalThis.__supabase__) {
    return globalThis.__supabase__;
  }

  // NOTE: Wir typisieren hier bewusst mit `any`, weil diese Codebase aktuell keine
  // vollständigen, generierten Supabase-Types im Repo hat. Ohne das führt `rpc()`
  // in vielen Dateien zu `never`-Fehlern.
  const client = createClient<any>(supabaseUrl, supabaseAnonKey, {
    auth: {
      storageKey: "hustle-auth-token",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
      lock: createInMemoryAuthLock(),
    },
  });

  globalThis.__supabase__ = client;
  // Debug-Log deaktiviert
  // console.log("🔧 Supabase Client erstellt (Singleton)");
  return client;
})();

// Admin-Client wird nicht mehr im Browser erstellt
// Service-Role-Key gehört serverseitig
// Für Admin-Operationen wird der normale Client verwendet
export const supabaseAdmin = supabase;
